<template>
    <v-stepper>
        <v-stepper-header>
            <router-link :to="`/pages/store/edit/` + this.$route.params.store_id">
                <v-stepper-step step="" :complete="current === 'store'">تنظیمات فروشگاه</v-stepper-step>
            </router-link>
            <v-divider></v-divider>

            <router-link :to="`/pages/product_categories/modify/` + this.$route.params.store_id">
                <v-stepper-step step="" :complete="current === 'product_categories'">دسته‌بندیها</v-stepper-step>
            </router-link>
            <v-divider></v-divider>

            <router-link :to="`/pages/template_setting/` + this.$route.params.store_id">
                <v-stepper-step step="" :complete="current === 'template_setting'">تنظیمات قالب</v-stepper-step>
            </router-link>
            <v-divider></v-divider>

            <router-link :to="`/pages/static_pages/modify/` + this.$route.params.store_id">
                <v-stepper-step step="" :complete="current === 'static_pages'">صفحات اضافه</v-stepper-step>
            </router-link>
            <v-divider></v-divider>

            <router-link :to="`/pages/payment_gateways/modify/` + this.$route.params.store_id">
                <v-stepper-step step="" :complete="current === 'payment_gateways'">درگاه‌پرداخت</v-stepper-step>
            </router-link>
            <v-divider></v-divider>

            <router-link :to="`/pages/users/list/` + this.$route.params.store_id">
                <v-stepper-step step="" :complete="current === 'users'">کاربران</v-stepper-step>
            </router-link>
        </v-stepper-header>
    </v-stepper>
</template>

<script>
export default {
  name: 'StoreStepper',
  props: {
    current: String
  }
};
</script>

<style scoped>
    .v-stepper__header a{
        text-decoration: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/StoreStepper.vue